var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportantDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.408,
    height: 78.674,
    viewBox: "0 0 94.408 78.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-important-devices",
    "data-name": "Icon material-important-devices",
    d: "M90.475,38.442,70.806,38.4a3.945,3.945,0,0,0-3.934,3.934v35.4a3.945,3.945,0,0,0,3.934,3.934H90.475a3.945,3.945,0,0,0,3.934-3.934v-35.4A3.912,3.912,0,0,0,90.475,38.442Zm0,35.364H70.806V46.27H90.475ZM78.674,3H7.867A7.84,7.84,0,0,0,0,10.867v47.2a7.865,7.865,0,0,0,7.867,7.867H35.4v7.867H27.536v7.867H59.005V73.806H51.138V65.939h7.867V58.071H7.867v-47.2H78.674V30.536h7.867V10.867A7.865,7.865,0,0,0,78.674,3ZM47.086,30.536l-3.816-11.8-3.816,11.8H27.536l9.716,6.923-3.7,11.447,9.716-7.081,9.716,7.081-3.7-11.447,9.716-6.923Z",
    transform: "translate(0 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantDevices);
export default __webpack_public_path__ + "static/media/important-devices.4ef560f5.svg";
export { ForwardRef as ReactComponent };